var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import LoaderHolder from './LoaderHolder';
function CodeStyle(props) {
    return (React.createElement(LoaderHolder, __assign({}, props),
        React.createElement("rect", { x: "0", y: "10", rx: "3", ry: "3", width: "70", height: "10" }),
        React.createElement("rect", { x: "80", y: "10", rx: "3", ry: "3", width: "100", height: "10" }),
        React.createElement("rect", { x: "190", y: "10", rx: "3", ry: "3", width: "10", height: "10" }),
        React.createElement("rect", { x: "15", y: "30", rx: "3", ry: "3", width: "130", height: "10" }),
        React.createElement("rect", { x: "155", y: "30", rx: "3", ry: "3", width: "130", height: "10" }),
        React.createElement("rect", { x: "15", y: "50", rx: "3", ry: "3", width: "90", height: "10" }),
        React.createElement("rect", { x: "115", y: "50", rx: "3", ry: "3", width: "60", height: "10" }),
        React.createElement("rect", { x: "185", y: "50", rx: "3", ry: "3", width: "60", height: "10" }),
        React.createElement("rect", { x: "0", y: "70", rx: "3", ry: "3", width: "30", height: "10" })));
}
export default CodeStyle;
